"use client";

import { FormControl, styled } from "@mui/material";

const FormSection = styled(FormControl)(({ theme }) => ({
  width: "100%",
  marginBottom: theme.spacing(4),
}));

export default FormSection;